import { ColumnDef } from '@tanstack/react-table';
import { IconButton } from '@mui/material';
import { Download } from '@mui/icons-material';

import { UserGuideType } from '../../types/UserGuideTypes';
import { dateHeader, formatCellDate } from './timeModeCell';

export const makeUserGuideColumns = (onDownload: (guide: UserGuideType) => void): ColumnDef<UserGuideType>[] => [
  {
    accessorKey: 'LastModifiedDate',
    header: dateHeader('Uploaded Date/Time'),
    cell: ({ row, table }) => formatCellDate(table, row.original.lastModifiedDate),
  },
  {
    accessorKey: 'fileName',
    header: 'Version',
    cell: ({ row }) => row.original.fileName,
  },
  {
    id: 'actions',
    header: 'Download',
    cell: ({ row }) => (
      <IconButton onClick={() => onDownload(row.original)} size='small'>
        <Download />
      </IconButton>
    ),
  },
];
